<template>
    <comp-9-prep-adherence :section="9" :page="35" :nextDisabled="nextDisabled" :next="nextScreen">
        <p>
            Would you like to explore ways that may help you to take PrEP regularly?
        </p>
        <v-radio-group v-model="prepRegularSupportSelection" column>
            <v-radio v-for="regularSupport in prepRegularSupports" :key="regularSupport.id" :label="regularSupport.text" :value="regularSupport"></v-radio>
        </v-radio-group>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepRegularSupportSelection: null
        };
    },
    computed: {
        prepRegularSupport() {
            let selectedPrepRegularSupport = find(this.prepRegularSupports, 'selected');

            if (selectedPrepRegularSupport) {
                return selectedPrepRegularSupport;
            } else return null;
        },
        prepRegularSupports: sync('section9/prepRegularSupport'),
        nextScreen() {
            if (this.prepRegularSupportSelection) {
                return `/page/9/${this.prepRegularSupportSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.prepRegularSupportSelection;
        }
    },
    watch: {
        prepRegularSupportSelection(newPrepRegularSupportSelection) {
            forEach(this.prepRegularSupports, o => {
                if (o.id === newPrepRegularSupportSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.prepRegularSupportSelection = this.prepRegularSupport;
    }
};
</script>
